import { SearchState } from 'src/app/interfaces/search.interface';
import { SocialInitiativeActionsShared } from './social-initiative-actions-shared.abstract';
import { defineCallParams } from './social-initiative.helpers';

export abstract class SocialInitiativeCommunityEntities extends SocialInitiativeActionsShared {
  public fetchPersonalEntities(state?: SearchState): void {
    const params: number[] = defineCallParams(null, state);
    this.fetchUserEntities(...params);
  }

  public fetchPersonalSpecificEntities(userId: string, state: SearchState): void {
    const paginationRelatedParams: number[] = defineCallParams(null, state);
    this.fetchUserSpecificEntities(userId, ...paginationRelatedParams);
  }

  public abstract fetchUserPersonalRequests(): void;
  public abstract fetchUserPersonalInvites(): void;

  protected abstract fetchUserEntities(offset?: number, limit?: number): void;
  protected abstract fetchUserSpecificEntities(userId: string, offset?: number, limit?: number): void;
}
